import Navbar from "../../components/shared/Navbar";
import Footer from "../../components/shared/Footer";
import BreadCumbDetailInformationAndNews from "../../components/detailInformationAndNews/BreadCrumbDetailInformationAndNews";
import Detail from "../../components/detailInformationAndNews/Detail";
import RightBar from "../../components/shared/RightBar";

export default function DetailInformationAndNews() {
    return (
        <div className="flex flex-col min-h-screen">
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <BreadCumbDetailInformationAndNews></BreadCumbDetailInformationAndNews>
                <Detail></Detail>
            </main>
            <Footer />
        </div>
    )
}